__turbopack_context__.v({
  "benefit": "DmsIntegrations-module__M4_XxG__benefit",
  "card": "DmsIntegrations-module__M4_XxG__card",
  "cardDelay1": "DmsIntegrations-module__M4_XxG__cardDelay1",
  "cardDelay2": "DmsIntegrations-module__M4_XxG__cardDelay2",
  "cardDelay3": "DmsIntegrations-module__M4_XxG__cardDelay3",
  "cardDelay4": "DmsIntegrations-module__M4_XxG__cardDelay4",
  "cardDelay5": "DmsIntegrations-module__M4_XxG__cardDelay5",
  "cardHead": "DmsIntegrations-module__M4_XxG__cardHead",
  "cardWrap": "DmsIntegrations-module__M4_XxG__cardWrap",
  "cardWrapWide": "DmsIntegrations-module__M4_XxG__cardWrapWide",
  "catTitle": "DmsIntegrations-module__M4_XxG__catTitle",
  "chip": "DmsIntegrations-module__M4_XxG__chip",
  "cta": "DmsIntegrations-module__M4_XxG__cta",
  "examples": "DmsIntegrations-module__M4_XxG__examples",
  "eyebrow": "DmsIntegrations-module__M4_XxG__eyebrow",
  "grid": "DmsIntegrations-module__M4_XxG__grid",
  "head": "DmsIntegrations-module__M4_XxG__head",
  "icon": "DmsIntegrations-module__M4_XxG__icon",
  "inView": "DmsIntegrations-module__M4_XxG__inView",
  "logoChip": "DmsIntegrations-module__M4_XxG__logoChip",
  "logoRail": "DmsIntegrations-module__M4_XxG__logoRail",
  "logoTrack": "DmsIntegrations-module__M4_XxG__logoTrack",
  "railInner": "DmsIntegrations-module__M4_XxG__railInner",
  "railScroll": "DmsIntegrations-module__M4_XxG__railScroll",
  "section": "DmsIntegrations-module__M4_XxG__section",
  "spinAccent": "DmsIntegrations-module__M4_XxG__spinAccent",
  "subtitle": "DmsIntegrations-module__M4_XxG__subtitle",
  "title": "DmsIntegrations-module__M4_XxG__title",
});
